/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.quality.rpc.CollectionsRpc
 */

export const AppCollectionItemsTypename = 'com.hubspot.marketplace.quality.models.rpcs.collections.AppCollectionItems';
export const CollectionNotFoundErrorTypename = 'com.hubspot.marketplace.quality.models.rpcs.collections.CollectionNotFoundError';
export const ModuleCollectionItemsTypename = 'com.hubspot.marketplace.quality.models.rpcs.collections.ModuleCollectionItems';
export const ThemeCollectionItemsTypename = 'com.hubspot.marketplace.quality.models.rpcs.collections.ThemeCollectionItems';
export const UnknownProductTypeErrorTypename = 'com.hubspot.marketplace.quality.models.rpcs.collections.UnknownProductTypeError';
export const UnsupportedProductTypeErrorTypename = 'com.hubspot.marketplace.quality.models.rpcs.collections.UnsupportedProductTypeError';
export const getRelevantPublishedIdsRpc = {
  serviceName: 'com.hubspot.marketplace.quality.rpc.CollectionsRpc',
  rpcName: 'getRelevantPublishedIds',
  auth: 'app',
  fingerprint: '930u9a0XP0HL6Im6rBloohKHfXazHxIe',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getItemsRpc = {
  serviceName: 'com.hubspot.marketplace.quality.rpc.CollectionsRpc',
  rpcName: 'getItems',
  auth: 'app',
  fingerprint: '530g2uqN44hkHxodrJoiwhKHfXazHxIe',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getCollectionsRpc = {
  serviceName: 'com.hubspot.marketplace.quality.rpc.CollectionsRpc',
  rpcName: 'getCollections',
  auth: 'app',
  fingerprint: 'By7BhwSrcxShIYKWkl_kHRKHfXazHxIe',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};